var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"imageWithVignette",staticClass:"image-with-vignette",style:(_vm.roundBordersStyle)},[_c('div',{staticClass:"image-wrapper",style:(_vm.roundBordersStyle)},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"vignette",style:(Object.assign(
      {}, _vm.vignetteStyle, _vm.roundBordersStyle))})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77b2f181","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-content/utils/Vignette.vue
// module id = null
// module chunks = 